import { Stack } from 'expo-router';
import React from 'react';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import { useShouldShowDesktopNavigation } from 'shared/hooks/useShouldShowDesktopNavigation';

function SpendBenefitsLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  if (shouldShowDesktopNavigation) {
    return (
      <DesktopNavigation>
        <Stack screenOptions={{ headerShown: false }} />
      </DesktopNavigation>
    );
  }

  return <Stack screenOptions={{ headerShown: false }} />;
}

export default SpendBenefitsLayoutWeb;
